/***********************
 * GROUPCALLS TABLE
 ************************/

import React, { useEffect, useState } from "react"
import { Row, Col } from "reactstrap"
import PropTypes from "prop-types"
import {
  formatDateFull,
  timeFormatter,
  formatDateTime,
  numSorter,
} from "utils/general"
//Translation
import { withTranslation } from "react-i18next"
import TableReporting from "components/Tables/TableReporting"

const GroupCallsTable = props => {
  //Excel and pdf name
  const [title] = useState(props.t("Group video calls"))
  //Table data state
  const [series, setSeries] = useState([])
  const [origSeries, setOrigSeries] = useState([])
  //Filtered data
  const [filteredData, setFilteredData] = useState(series)
  const [handleValue, setHandleValue] = useState("")
  const [loading, setLoading] = useState(true)

  //Setting data state
  useEffect(() => {
    console.log("Data table group calls: " + JSON.stringify(props.data.list))
    if (props.data.list) {
      let sorted = props.data.list.sort((a, b) => b.start - a.start)
      // console.log("SORTED:", sorted)
      setOrigSeries(sorted)
      setSeries(sorted)
      setLoading(false)
    }
  }, [props.data])

  useEffect(() => {
    if (series != undefined) {
      setFilteredData(series)
      console.log("series: ", series)
      if (handleValue != "") {
        handlingInput(handleValue)
      }
    }
  }, [series])

  // Table structure
  const columns1 = [
    {
      dataIndex: "start",
      title: props.t("Start time"),
      width: 150,
      sorter: (a, b) => numSorter(a.start, b.start),
      render: value => formatDateFull(value),
    },
    {
      dataIndex: "end",
      title: props.t("End time"),
      width: 150,
      sorter: (a, b) => numSorter(a.end, b.end),
      render: value => formatDateFull(value),
    },
    {
      dataIndex: "duration",
      title: props.t("Duration"),
      width: 120,
      sorter: (a, b) => numSorter(a.duration, b.duration),
      formatter: timeFormatter,
    },
    {
      dataIndex: "total_users",
      title: props.t("Participants"),
      width: 120,
      sorter: (a, b) => numSorter(a.total_users, b.total_users),
    },
    {
      dataIndex: "unique_users",
      title: props.t("Users"),
      width: 120,
      sorter: (a, b) => numSorter(a.unique_users, b.unique_users),
    },
    {
      dataIndex: "record_id",
      title: props.t("Record ID"),
      width: 190,
      sorter: (a, b) => numSorter(a.record_id, b.record_id),
    },
    {
      dataIndex: "clients",
      title: props.t("Participants info"),
      render: value => formatParticipants(value),
    },
  ]

  // Export values
  const pdfHeading = [
    props.t("Start time"),
    props.t("End time"),
    props.t("Duration"),
    props.t("Participants"),
    props.t("Users"),
    props.t("Record ID"),
    props.t("Participants"),
  ]
  const pdfData = filteredData.map(elt => [
    formatDateFull(elt.start),
    formatDateFull(elt.end),
    timeFormatter(elt.duration),
    elt.unique_users,
    elt.total_users,
    elt.record_id,
    elt.clients,
  ])

  const xlsxHeading = [pdfHeading]

  const xlsxData = filteredData.map(elt => [
    formatDateFull(elt.start),
    formatDateFull(elt.end),
    timeFormatter(elt.duration),
    elt.total_users,
    elt.unique_users,
    elt.record_id,
    elt.clients,
  ])

  const handlingInput = value => {
    let result = []
    result = series.filter(data => data.clients?.toLowerCase().includes(value))

    setFilteredData(result)

    // Set original data result if value ""
    if (value == "") {
      setFilteredData(series)
    }
  }

  // Handle search function
  const handleSearch = event => {
    let value = event.target.value.toLowerCase()
    setHandleValue(value)
    handlingInput(value)
  }

  // Can be used to modify type
  function formatParticipants(cell) {
    let formatted = JSON.parse(cell)

    const itemsTogetherJSX = []

    for (const item of formatted) {
      itemsTogetherJSX.push(
        <div style={{ width: "600px" }}>
          <Col lg="12" className="mb-1" key={"_col_" + item.id}>
            <Row>
              <Col sm="4">
                {item.isHost == "1" ? (
                  <div className="mb-0 text-muted">
                    <strong>
                      <small className="mb-0">{props.t("Host")}</small>
                    </strong>
                  </div>
                ) : (
                  <div className="mb-0 text-muted">
                    <small className="mb-0">{props.t("Participant")}</small>
                  </div>
                )}
                {item.name}
                {item.unit ? (
                  <div className="font-size-12">
                    <em>{props.t("Unit info")}:</em> {item.unit}
                  </div>
                ) : (
                  <></>
                )}
              </Col>
              <Col sm="2">
                <small className="mb-0 text-muted">{props.t("Time")}</small>
                <div>
                  {formatDateTime(item.start)}-{formatDateTime(item.end)}
                </div>
              </Col>
              <Col sm="2">
                <small className="mb-0 text-muted">{props.t("Duration")}</small>{" "}
                <div>{timeFormatter(item.duration)}</div>
              </Col>
              <Col sm="2">
                {item.ringTime ? (
                  <>
                    <small className="mb-0 text-muted">
                      {props.t("Ring time")}
                    </small>
                    <div>{timeFormatter(item.ringTime)}</div>
                  </>
                ) : (
                  <></>
                )}
              </Col>
              <Col sm="2">
                <small className="mb-0 text-muted">{props.t("Room")}</small>
                <div>{item.room}</div>
              </Col>
            </Row>
          </Col>
        </div>
      )
    }

    return itemsTogetherJSX
  }

  return (
    <React.Fragment>
      <TableReporting
        origSeries={origSeries}
        setSeries={setSeries}
        title={title}
        columns={columns1}
        seriesFiltered={filteredData}
        xlsxHeading={xlsxHeading}
        xlsxData={xlsxData}
        pdfHeading={pdfHeading}
        pdfData={pdfData}
        handleSearch={handleSearch}
        loading={loading}
        hover={false}
      ></TableReporting>
    </React.Fragment>
  )
}

GroupCallsTable.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
}

export default withTranslation()(GroupCallsTable)
